import { render, staticRenderFns } from "./gc-popup-process-shift-recurring-deduction.vue?vue&type=template&id=a5543e72"
import script from "./gc-popup-process-shift-recurring-deduction.vue?vue&type=script&lang=js"
export * from "./gc-popup-process-shift-recurring-deduction.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-process-shift-recurring-deduction.vue?vue&type=style&index=0&id=a5543e72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports